// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer{position:relative;--tw-bg-opacity:1;background-color:rgba(0,61,76,var(--tw-bg-opacity));--tw-text-opacity:1;color:rgba(255,255,255,var(--tw-text-opacity));padding-top:68px}.footer__bottom{padding-top:25px;padding-bottom:30px}.footer__hr{border-top:1px solid #fff}.footer__hr,.footer__langswitch--mobile{margin-bottom:30px}", ""]);
// Exports
module.exports = exports;
